// extracted by mini-css-extract-plugin
export default {"brand-logo":"product-brand-logo__brand-logo___1FdUG"};